import React from 'react';
import './index.css';
import ReactDOM from "react-dom";
import { HashRouter, Redirect, Switch, Route, NavLink } from 'react-router-dom';
import {getName, getToken, getUnits, setUnits} from "./storage/user";

import LoginScreen from "./component/login/login-screen";
import UploadScreen from "./component/upload/upload-screen";
import JumpsScreen from "./component/jumps/jumps-screen";

import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Logout from "./component/navbar/logout";

import ReactGA from 'react-ga';
ReactGA.initialize('UA-167435176-1');

export const UnitsContext = React.createContext({
    units: 'metric',
    toggleUnits: (units) => {},
});

export const LoggedInContext = React.createContext({
    loggedIn: getName(),
    toggleLoggedIn: () => {}
});

function PrivateRoute({ component: Component, ...rest }) {
    return (
        <Route
            {...rest}
            render={
                (props) => getToken()
                    ? <Component {...props} />
                    : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            }
        />
    )
}

class App extends React.Component {
    constructor(props) {
        super(props);

        this.toggleUnits = (value) => {
            setUnits(value);
            this.setState(state => ({
                units: value
            }));
        };

        this.toggleLoggedIn = () => {
            this.setState(state => ({
                loggedIn: !state.loggedIn
            }))
        }

        this.state = {
            units: getUnits() || 'metric',
            toggleUnits: this.toggleUnits,
            loggedIn: getName(),
            toggleLoggedIn: this.toggleLoggedIn
        };
    }

    render() {
        return (
            <UnitsContext.Provider value={this.state}>
                <LoggedInContext.Provider value={this.state}>
                    <Content/>
                </LoggedInContext.Provider>
            </UnitsContext.Provider>
        );
    }
}

function Content() {
    return (
        <HashRouter hashType="hashbang">
            <Navbar collapseOnSelect expand="lg" variant="dark" className="bg-skyduck" fixed="top">
                <Navbar.Brand href="#">
                    <img src="logo.svg" alt="Skyduck"/>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mr-auto">
                        <NavLink className="nav-link navlink-color" to="/">Logbook</NavLink>
                        <NavLink className="nav-link navlink-color" to="/upload">Add jumps</NavLink>
                    </Nav>
                    <Nav>
                        <Logout/>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
            <Switch>
                <Route path="/login" component={LoginScreen} />
                <PrivateRoute exact path="/" component={JumpsScreen} />
                <PrivateRoute path="/upload" component={UploadScreen} />
                <Route path="*">
                    <Redirect to={{ pathname: '/'}} />
                </Route>
            </Switch>
        </HashRouter>
    );
}

ReactDOM.render(<App/>, document.getElementById('root'));
